import { supabase } from '../lib/supabase';

/**
 * Get all active notifications (for public display)
 */
export const getActiveNotifications = async () => {
  try {
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .eq('is_active', true)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching active notifications:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching active notifications:', error);
    return { success: false, error };
  }
};

/**
 * Get all notifications (for admin view)
 */
export const getAllNotifications = async () => {
  try {
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error fetching all notifications:', error);
      return { success: false, error };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Error fetching all notifications:', error);
    return { success: false, error };
  }
};

/**
 * Create a new notification
 */
export const createNotification = async (notificationData) => {
  try {
    const { data, error } = await supabase
      .from('notifications')
      .insert([notificationData])
      .select()
      .single();

    if (error) {
      console.error('Error creating notification:', error);
      return { success: false, error, message: 'فشل في إنشاء الإشعار' };
    }

    return { success: true, data, message: 'تم إنشاء الإشعار بنجاح' };
  } catch (error) {
    console.error('Error creating notification:', error);
    return { success: false, error, message: 'فشل في إنشاء الإشعار' };
  }
};

/**
 * Update a notification
 */
export const updateNotification = async (id, updates) => {
  try {
    const { data, error } = await supabase
      .from('notifications')
      .update(updates)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      console.error('Error updating notification:', error);
      return { success: false, error, message: 'فشل في تحديث الإشعار' };
    }

    return { success: true, data, message: 'تم تحديث الإشعار بنجاح' };
  } catch (error) {
    console.error('Error updating notification:', error);
    return { success: false, error, message: 'فشل في تحديث الإشعار' };
  }
};

/**
 * Delete a notification
 */
export const deleteNotification = async (id) => {
  try {
    const { error } = await supabase
      .from('notifications')
      .delete()
      .eq('id', id);

    if (error) {
      console.error('Error deleting notification:', error);
      return { success: false, error, message: 'فشل في حذف الإشعار' };
    }

    return { success: true, message: 'تم حذف الإشعار بنجاح' };
  } catch (error) {
    console.error('Error deleting notification:', error);
    return { success: false, error, message: 'فشل في حذف الإشعار' };
  }
};

/**
 * Toggle notification active status
 */
export const toggleNotificationStatus = async (id, isActive) => {
  return updateNotification(id, { is_active: isActive });
};

/**
 * Check if a notification has been dismissed by the user
 */
export const isNotificationDismissed = (notificationId) => {
  try {
    const dismissed = localStorage.getItem('dismissed_notifications');
    if (!dismissed) return false;
    const dismissedList = JSON.parse(dismissed);
    return dismissedList.includes(notificationId);
  } catch (error) {
    console.error('Error checking dismissed notifications:', error);
    return false;
  }
};

/**
 * Mark a notification as dismissed for the current user
 */
export const dismissNotification = (notificationId) => {
  try {
    const dismissed = localStorage.getItem('dismissed_notifications');
    let dismissedList = dismissed ? JSON.parse(dismissed) : [];
    
    if (!dismissedList.includes(notificationId)) {
      dismissedList.push(notificationId);
      localStorage.setItem('dismissed_notifications', JSON.stringify(dismissedList));
    }
    
    return true;
  } catch (error) {
    console.error('Error dismissing notification:', error);
    return false;
  }
};


